import { useTranslation } from 'react-i18next'
import { Departure, WidgetTranslations } from '../data.ts'
import { type Ref, useCallback, useMemo, useState } from 'react'
import { groupDeparturesByStatus } from '@/lib/departures.ts'
import { DepartureListGroup } from '@/components/departure-list-group.tsx'

export function DepartureList ({ departures, translations, ref }: {
  departures: Departure[]
  translations: WidgetTranslations
  ref?: Ref<HTMLDivElement>
}): JSX.Element {
  const { t } = useTranslation('widget')
  const [maxVisible, setMaxVisible] = useState(10)
  const expand = useCallback(() => {
    setMaxVisible(prev => prev + 10)
  }, [])

  const departureGroups = useMemo(() => groupDeparturesByStatus(departures), [departures])

  return (
    <div
      ref={ref}
      className='isolate grid grid-cols-1 [--cols:7] @desktop:grid-cols-[auto_auto_auto_1fr_auto_1fr_auto] gap-y-4 @desktop:gap-x-6 mt-4 bg-white pt-4 @desktop:pt-0 [--scroll-padding:4.25rem] @desktop:[--scroll-padding:2.25rem] scroll-mt-[calc(var(--sticky-header-height,134px)+var(--scroll-padding,0))]'
    >
      <div className='hidden @desktop:contents font-bold'>
        <div className='col-span-2'>{t('date')}</div>
        <div className='col-span-2'>{t('departure')}</div>
        <div className='col-span-2'>{t('ship')}</div>
        <div />
      </div>
      {departureGroups.map(departureGroup => (
        <DepartureListGroup
          key={departureGroup.index} departureGroup={departureGroup} translations={translations} maxVisible={maxVisible}
        />
      ))}
      {departures.length > maxVisible && (
        <div className='@desktop:col-span-[--cols] grid'>
          <button
            type='button' onClick={expand}
            className='flex justify-center gap-3 items-center rounded-md text-brand-primary border-2 border-brand-primary py-1 px-3 font-bold cursor-pointer'
          >{t('load_more', 'Load more')}
          </button>
        </div>
      )}
    </div>
  )
}
